import {Button} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import React from "react";

// Компонент кнопки удаления

export const RemoveButton = ({onClick}) => (
    <Button
        type="text"
        danger
        size="small"
        icon={<CloseOutlined/>}
        onClick={onClick}
    />
);